export const tagInfo = {
  s: {
    type: "s",
    tagText: "주어",
    text: "S",
    backgroundColor: "rgba(67, 140, 251, 0.1)",
    color: "rgba(67, 140, 251, 1)",
  },
  fs: {
    type: "fs",
    tagText: "가주어",
    text: "S(가주어)",
    backgroundColor: "rgba(67, 140, 251, 0.1)",
    color: "rgba(67, 140, 251, 1)",
  },
  ls: {
    type: "ls",
    tagText: "의미상 주어",
    text: "S(의미상 주어)",
    backgroundColor: "rgba(67, 140, 251, 0.1)",
    color: "rgba(67, 140, 251, 1)",
  },
  v: {
    type: "v",
    tagText: "동사",
    text: "V",
    backgroundColor: "rgba(255, 68, 68, 0.1)",
    color: "rgba(255, 68, 68, 1)",
  },
  o: {
    type: "o",
    tagText: "목적어",
    text: "O",
    backgroundColor: "rgba(45, 240, 52, 0.1)",
    color: "rgba(45, 240, 52, 1)",
  },
  io: {
    type: "io",
    tagText: "간접 목적어",
    text: "O(간접 목적어)",
    backgroundColor: "rgba(45, 240, 52, 0.1)",
    color: "rgba(45, 240, 52, 1)",
  },
  do: {
    type: "do",
    tagText: "직접 목적어",
    text: "O(직접 목적어)",
    backgroundColor: "rgba(45, 240, 52, 0.1)",
    color: "rgba(45, 240, 52, 1)",
  },
  fo: {
    type: "fo",
    tagText: "가목적어",
    text: "O(가목적어)",
    backgroundColor: "rgba(45, 240, 52, 0.1)",
    color: "rgba(45, 240, 52, 1)",
  },
  sc: {
    type: "sc",
    tagText: "주격 보어",
    text: "S·C",
    backgroundColor: "rgba(67, 190, 251, 0.1)",
    color: "rgba(67, 190, 251, 1)",
  },
  oc: {
    type: "oc",
    tagText: "목적격 보어",
    text: "O·C",
    backgroundColor: "rgba(67, 190, 251, 0.1)",
    color: "rgba(67, 190, 251, 1)",
  },
};

export const phraseInfo = {
  "cls:noun:s": {
    type: "cls:noun:s",
    tagText: "주어절",
    text: "S(주어절)",
    backgroundColor: "rgba(67, 140, 251, 0.1)",
    color: "rgba(67, 140, 251, 1)",
  },
  "cls:noun:rs": {
    type: "cls:noun:rs",
    tagText: "진주어절",
    text: "S(진주어절)",
    backgroundColor: "rgba(67, 140, 251, 0.1)",
    color: "rgba(67, 140, 251, 1)",
  },
  "phr:noun:rs": {
    type: "phr:noun:rs",
    tagText: "진주어구",
    text: "S(진주어구)",
    backgroundColor: "rgba(67, 140, 251, 0.1)",
    color: "rgba(67, 140, 251, 1)",
  },
  "cls:noun:o": {
    type: "cls:noun:o",
    tagText: "목적어절",
    text: "O(목적어절)",
    backgroundColor: "rgba(45, 240, 52, 0.1)",
    color: "rgba(45, 240, 52, 1)",
  },
  "cls:noun:ro": {
    type: "cls:noun:ro",
    tagText: "진목적어절",
    text: "O(진목적어절)",
    backgroundColor: "rgba(45, 240, 52, 0.1)",
    color: "rgba(45, 240, 52, 1)",
  },
  "phr:noun:ro": {
    type: "phr:noun:ro",
    tagText: "진목적어구",
    text: "O(진목적어구)",
    backgroundColor: "rgba(45, 240, 52, 0.1)",
    color: "rgba(45, 240, 52, 1)",
  },
  "cls:noun:sc": {
    type: "cls:noun:sc",
    tagText: "주격 보어절",
    text: "S·C(주격 보어절)",
    backgroundColor: "rgba(67, 190, 251, 0.1)",
    color: "rgba(67, 190, 251, 1)",
  },
  "phr:prep": {
    type: "phr:prep",
    tagText: "전치사구",
    text: "전치사구",
    backgroundColor: "rgba(208, 90, 8, 0.1)",
    color: "rgba(208, 90, 8, 1)",
  },
  "phr:adj": {
    type: "phr:adj",
    tagText: "형용사구",
    text: "형용사구",
    backgroundColor: "rgba(208, 90, 8, 0.1)",
    color: "rgba(208, 90, 8, 1)",
  },
  "phr:adv": {
    type: "phr:adv",
    tagText: "부사구",
    text: "부사구",
    backgroundColor: "rgba(208, 90, 8, 0.1)",
    color: "rgba(208, 90, 8, 1)",
  },
  "phr:adj:ptc:present": {
    type: "phr:adj:ptc:present",
    tagText: "현재분사",
    text: "현재분사",
    backgroundColor: "rgba(208, 90, 8, 0.1)",
    color: "rgba(208, 90, 8, 1)",
  },
  "phr:adj:ptc:past": {
    type: "phr:adj:ptc:past",
    tagText: "과거분사",
    text: "과거분사",
    backgroundColor: "rgba(208, 90, 8, 0.1)",
    color: "rgba(208, 90, 8, 1)",
  },
  "phr:adj:to_inf": {
    type: "phr:adj:to_inf",
    tagText: "to부정사(형)",
    text: "to부정사(형)",
    backgroundColor: "rgba(208, 90, 8, 0.1)",
    color: "rgba(208, 90, 8, 1)",
  },
  "phr:adv:to_inf": {
    type: "phr:adv:to_inf",
    tagText: "to부정사(부)",
    text: "to부정사(부)",
    backgroundColor: "rgba(208, 90, 8, 0.1)",
    color: "rgba(208, 90, 8, 1)",
  },
  "const:ptc:present": {
    type: "const:ptc:present",
    tagText: "현재분사구문",
    text: "현재분사구문",
    backgroundColor: "rgba(208, 90, 8, 0.1)",
    color: "rgba(208, 90, 8, 1)",
  },
  "const:ptc:past": {
    type: "const:ptc:past",
    tagText: "과거분사구문",
    text: "과거분사구문",
    backgroundColor: "rgba(208, 90, 8, 0.1)",
    color: "rgba(208, 90, 8, 1)",
  },
  "cls:adv": {
    type: "cls:adv",
    tagText: "부사절",
    text: "부사절",
    backgroundColor: "rgba(191, 53, 140, 0.1)",
    color: "rgba(191, 53, 140, 1)",
  },
  "cls:rel": {
    type: "cls:rel",
    tagText: "관계절",
    text: "관계절",
    backgroundColor: "rgba(191, 53, 140, 0.1)",
    color: "rgba(191, 53, 140, 1)",
  },
  "cls:rel:s": {
    type: "cls:rel:s",
    tagText: "관·대(주)",
    text: "관·대(주)",
    backgroundColor: "rgba(191, 53, 140, 0.1)",
    color: "rgba(191, 53, 140, 1)",
  },
  "cls:rel:o": {
    type: "cls:rel:o",
    tagText: "관·대(목)",
    text: "관·대(목)",
    backgroundColor: "rgba(191, 53, 140, 0.1)",
    color: "rgba(191, 53, 140, 1)",
  },
  "cls:rel:adv": {
    type: "cls:rel:adv",
    tagText: "관·부",
    text: "관·부",
    backgroundColor: "rgba(191, 53, 140, 0.1)",
    color: "rgba(191, 53, 140, 1)",
  },
  "cls:rel:pos": {
    type: "cls:rel:pos",
    tagText: "관·대(소)",
    text: "관·대(소)",
    backgroundColor: "rgba(191, 53, 140, 0.1)",
    color: "rgba(191, 53, 140, 1)",
  },
  "cls:appos": {
    type: "cls:appos",
    tagText: "동격절",
    text: "동격절",
    backgroundColor: "rgba(191, 53, 140, 0.1)",
    color: "rgba(191, 53, 140, 1)",
  },
};
